import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { OutreachContactsContext, SortOption } from "contexts/OutreachContacts";
import { useContext, useMemo } from "react";
import { CustomEvent } from "schemas/functions";

import styles from "./styles";

export default function SortSelect() {
  const { fetchContactsParams, handleFetchContacts, getSortOptions } =
    useContext(OutreachContactsContext);

  const SORTS = getSortOptions();

  const handleChange = (e: CustomEvent) => {
    const { value } = e.target;
    const newValue = SORTS.find((sort) => sort.name === value) || SORTS[0];
    const updatedParams = { ...fetchContactsParams };
    updatedParams.page = 1;
    updatedParams.order = newValue.order;
    updatedParams.orderBy = newValue.orderBy;
    handleFetchContacts(updatedParams);
  };

  const sortValue = useMemo(() => {
    return (
      SORTS.find(
        (sort) =>
          sort.order === fetchContactsParams.order &&
          sort.orderBy === fetchContactsParams.orderBy,
      ) || SORTS[0]
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchContactsParams.order, fetchContactsParams.orderBy]);

  return (
    <FormControl variant="outlined" size="small" fullWidth>
      <Select
        sx={styles.sortBy}
        onChange={handleChange}
        value={sortValue.name}
        renderValue={(selectedValue) => {
          // You can customize the display based on the selectedValue
          if (selectedValue === "") {
            return <em>Sort by</em>;
          }
          return (
            <>
              {" "}
              <Box
                sx={{ mr: 1 }}
                component="i"
                className="fa-solid fa-arrow-up-arrow-down"
              />
              {selectedValue}{" "}
            </>
          );
        }}
      >
        {SORTS?.map((sort: SortOption) => (
          <MenuItem key={sort.name} value={sort.name}>
            {sort.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
